import { typedPageSelectors, usePage } from 'publisher/store'
import React from 'react'
import { BasePublisherButton } from 'src/publisher/entities/base-publisher-button'
import { LoginButtonInterface } from 'src/shared/types/entities/login-button-interface'

const TEST_ID = 'login-button'

export interface LoginButtonProps {
  entity: LoginButtonInterface
}

export const LoginButton = ({ entity }: LoginButtonProps) => {
  const locale = usePage(state => typedPageSelectors.getLocale(state))

  return (
    <BasePublisherButton
      entity={entity}
      onClick={() => {
        location.assign(`/${locale}/login`)
      }}
      testId={TEST_ID}
    />
  )
}
